import React from "react";
import "./TenantTourControls.scss";

// Import existing React Icons used in the project
import { HiOutlineArrowPath } from "react-icons/hi2";
import { MdExplore } from "react-icons/md";
const TenantTourControls = ({ startTour, resetTour }) => {
  // Only show in development mode
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <div className="tenant-tour-controls">
      <button
        className="tour-control-btn tour-start-btn"
        onClick={startTour}
        title="Start Tour"
      >
        <MdExplore size={25} />
      </button>
      <button
        className="tour-control-btn tour-reset-btn"
        onClick={resetTour}
        title="Reset Tour (Clear completed status)"
      >
        <HiOutlineArrowPath size={25} />
      </button>
    </div>
  );
};

export default TenantTourControls;
